import { useMemo, FC } from 'react';
import classNames from 'classnames';
import { RemoveMappingIcon } from './RemoveMappingIcon';

interface IInvalidMappingIconProps {
  x: number;
  y: number;
  isHovered?: boolean;
  onMouseEnter?: (e: React.MouseEvent) => void;
  onMouseLeave?: (e: React.MouseEvent) => void;
  onRemoveMapping: React.MouseEventHandler;
}

const INVALID_MAPPING_ICON = 'dp-invalid-mapping-icon';

const INVALID_ICON_SIGN_COLOR = '#FFF';
const INVALID_ICON_BACK_COLOR = '#E60000';

const EXCLAMATION_POINT_WIDTH = 2.28;
const EXCLAMATION_POINT_HEIGHT = 9.04;
const REMOVE_ICON_X_OFFSET = -25;

/**
 * Invalid Mapping Icon
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export const InvalidMappingIcon: FC<IInvalidMappingIconProps> = ({
  x,
  y,
  onMouseEnter,
  onMouseLeave,
  isHovered,
  onRemoveMapping,
}) => {
  const iconAreaTranslate = useMemo(() => `translate(${x}, ${y})`, [x, y]);
  const exclamationPointTranslate = `translate(
    ${-Math.abs(EXCLAMATION_POINT_WIDTH / 2)},
    ${-Math.abs(EXCLAMATION_POINT_HEIGHT / 2)}
  )`;

  return (
    <g className={getClassName(isHovered)} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <RemoveMappingIcon
        // onMouseEnter={onMouseEnter}
        // onMouseLeave={onMouseLeave}
        visible={!!isHovered}
        x={x + REMOVE_ICON_X_OFFSET}
        y={y}
        onClick={onRemoveMapping}
      />
      <g transform={iconAreaTranslate}>
        <rect width="30" height="42" fill="transparent" strokeWidth={0} transform={'translate(-14, -22)'}>
          {/* this circle is just for hover interactions */}
        </rect>
        <circle r="9" fill={INVALID_ICON_BACK_COLOR} stroke={INVALID_ICON_SIGN_COLOR} strokeWidth="2"></circle>
        <g transform={exclamationPointTranslate}>
          <path
            d="M1.49999 6.76C2.12959 6.76 2.63999 7.2704 2.63999 7.9C2.63999 8.5296 2.12959 9.04 1.49999 9.04C0.870381 9.04 0.359985 8.5296 0.359985 7.9C0.359985 7.2704 0.870381 6.76 1.49999 6.76ZM2.53999 0L2.63999 0.0999999L2.63898 2.19414L2.11898 5.83414L2.01999 5.92H0.979985L0.880991 5.83414L0.359985 2.18V0.0999999L0.459985 0H2.53999Z"
            stroke={INVALID_ICON_SIGN_COLOR}
            strokeWidth="0.1"
            fill={INVALID_ICON_SIGN_COLOR}
          />
        </g>
      </g>
    </g>
  );
};

function getClassName(isHovered?: boolean) {
  return classNames(INVALID_MAPPING_ICON, {
    [`${INVALID_MAPPING_ICON}--hovered`]: isHovered,
  });
}
